(function () {
  'use strict';

  function initAhlAlHajj(root) {
    if (!root || root.dataset.ahlInitialized === 'true') return;

    root.dataset.ahlInitialized = 'true';

    const player = root.querySelector('[data-ahl-player]');
    const playerTitle = root.querySelector('[data-ahl-player-title]');
    const playerMeta = root.querySelector('[data-ahl-player-meta]');
    const playerSummary = root.querySelector('[data-ahl-player-summary]');
    const playerArticle = root.querySelector('[data-ahl-player-article]');

    const episodeCards = Array.from(
      root.querySelectorAll('[data-ahl-episode]')
    );

    const filterButtons = Array.from(
      root.querySelectorAll('[data-ahl-filter]')
    );

    function normalize(value) {
      return String(value || '')
        .trim()
        .toLowerCase();
    }

    function youtubeEmbedUrl(url) {
      if (!url) return '';

      try {
        const parsed = new URL(url, window.location.origin);
        let videoId = '';

        if (parsed.hostname.includes('youtu.be')) {
          videoId = parsed.pathname.replace('/', '').split('/')[0];
        }

        if (parsed.hostname.includes('youtube.com')) {
          if (parsed.pathname === '/watch') {
            videoId = parsed.searchParams.get('v') || '';
          }

          if (parsed.pathname.startsWith('/embed/')) {
            videoId = parsed.pathname.split('/embed/')[1].split('/')[0];
          }

          if (parsed.pathname.startsWith('/shorts/')) {
            videoId = parsed.pathname.split('/shorts/')[1].split('/')[0];
          }

          if (parsed.pathname.startsWith('/live/')) {
            videoId = parsed.pathname.split('/live/')[1].split('/')[0];
          }
        }

        if (!videoId) return '';

        return (
          'https://www.youtube-nocookie.com/embed/' +
          encodeURIComponent(videoId) +
          '?rel=0&modestbranding=1'
        );
      } catch (error) {
        return '';
      }
    }

    function vimeoEmbedUrl(url) {
      if (!url) return '';

      try {
        const parsed = new URL(url, window.location.origin);

        if (!parsed.hostname.includes('vimeo.com')) return '';

        const parts = parsed.pathname
          .split('/')
          .filter(Boolean);

        const videoId = parts.find(function (part) {
          return /^\d+$/.test(part);
        });

        if (!videoId) return '';

        return (
          'https://player.vimeo.com/video/' +
          encodeURIComponent(videoId)
        );
      } catch (error) {
        return '';
      }
    }

    function createIframe(src, title) {
      const iframe = document.createElement('iframe');

      iframe.src = src;
      iframe.title = title || 'Vidéo AHL AL-HAJJ';
      iframe.loading = 'lazy';
      iframe.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';

      return iframe;
    }

    function createVideo(src, title, poster) {
      const video = document.createElement('video');

      video.controls = true;
      video.preload = 'metadata';
      video.playsInline = true;

      if (poster) {
        video.poster = poster;
      }

      video.setAttribute(
        'aria-label',
        title || 'Vidéo AHL AL-HAJJ'
      );

      const source = document.createElement('source');
      source.src = src;

      video.appendChild(source);

      return video;
    }

    function loadEpisode(card, options) {
      if (!card || !player) return;

      const settings = options || {};
      const videoUrl = card.dataset.video || '';
      const title = card.dataset.title || '';
      const meta = card.dataset.meta || '';
      const summary = card.dataset.summary || '';
      const articleUrl = card.dataset.article || '';
      const poster = card.dataset.poster || '';

      const youtubeUrl = youtubeEmbedUrl(videoUrl);
      const vimeoUrl = vimeoEmbedUrl(videoUrl);

      player.innerHTML = '';

      if (youtubeUrl) {
        player.appendChild(
          createIframe(youtubeUrl, title)
        );
      } else if (vimeoUrl) {
        player.appendChild(
          createIframe(vimeoUrl, title)
        );
      } else if (videoUrl) {
        player.appendChild(
          createVideo(videoUrl, title, poster)
        );
      } else if (poster) {
        const image = document.createElement('img');

        image.src = poster;
        image.alt = title;
        image.className = 'ahl-player__poster';

        player.appendChild(image);
      }

      if (playerTitle) {
        playerTitle.textContent = title;
      }

      if (playerMeta) {
        playerMeta.textContent = meta;
      }

      if (playerSummary) {
        playerSummary.textContent = summary;
      }

      if (playerArticle) {
        if (articleUrl) {
          playerArticle.href = articleUrl;
          playerArticle.hidden = false;
        } else {
          playerArticle.removeAttribute('href');
          playerArticle.hidden = true;
        }
      }

      episodeCards.forEach(function (episode) {
        episode.classList.remove('is-selected');
        episode.setAttribute('aria-current', 'false');
      });

      card.classList.add('is-selected');
      card.setAttribute('aria-current', 'true');

      if (settings.scroll === true) {
        const featured = root.querySelector(
          '[data-ahl-featured]'
        );

        if (featured) {
          featured.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    }

    episodeCards.forEach(function (card) {
      card.setAttribute('tabindex', '0');
      card.setAttribute('role', 'button');

      card.addEventListener('click', function (event) {
        if (event.target.closest('a')) return;

        loadEpisode(card, {
          scroll: true
        });
      });

      card.addEventListener('keydown', function (event) {
        if (
          event.key !== 'Enter' &&
          event.key !== ' '
        ) {
          return;
        }

        event.preventDefault();

        loadEpisode(card, {
          scroll: true
        });
      });
    });

    function applyFilter(button) {
      if (!button) return;

      const requestedFilter = normalize(
        button.dataset.ahlFilter
      );

      filterButtons.forEach(function (filterButton) {
        const isActive = filterButton === button;

        filterButton.classList.toggle(
          'is-active',
          isActive
        );

        filterButton.setAttribute(
          'aria-pressed',
          isActive ? 'true' : 'false'
        );
      });

      episodeCards.forEach(function (card) {
        const season = normalize(card.dataset.season);
        const country = normalize(card.dataset.country);
        const themes = normalize(card.dataset.themes);

        const searchableValues = [
          season,
          country,
          themes
        ].join(' ');

        const shouldShow =
          requestedFilter === '' ||
          requestedFilter === 'all' ||
          searchableValues.includes(requestedFilter);

        card.hidden = !shouldShow;
      });

      const visibleCards = episodeCards.filter(
        function (card) {
          return !card.hidden;
        }
      );

      const emptyState = root.querySelector(
        '[data-ahl-filter-empty]'
      );

      if (emptyState) {
        emptyState.hidden = visibleCards.length > 0;
      }
    }

    filterButtons.forEach(function (button) {
      button.setAttribute('aria-pressed', 'false');

      button.addEventListener('click', function () {
        applyFilter(button);
      });
    });

    const defaultFilter =
      filterButtons.find(function (button) {
        return button.classList.contains('is-active');
      }) || filterButtons[0];

    if (defaultFilter) {
      applyFilter(defaultFilter);
    }

    const initialEpisode =
      episodeCards.find(function (card) {
        return card.dataset.featured === 'true';
      }) || episodeCards[0];

    if (initialEpisode && player) {
      loadEpisode(initialEpisode, {
        scroll: false
      });
    }

    const anchorLinks = Array.from(
      root.querySelectorAll('a[href^="#"]')
    );

    anchorLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        const targetId = link.getAttribute('href');

        if (!targetId || targetId === '#') return;

        const target = root.querySelector(targetId);

        if (!target) return;

        event.preventDefault();

        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    });
  }

  function initAllAhlAlHajj() {
    const roots = document.querySelectorAll(
      '[data-ahl-root]'
    );

    roots.forEach(function (root) {
      initAhlAlHajj(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAllAhlAlHajj
    );
  } else {
    initAllAhlAlHajj();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      const root =
        event.target.matches &&
        event.target.matches('[data-ahl-root]')
          ? event.target
          : event.target.querySelector
            ? event.target.querySelector('[data-ahl-root]')
            : null;

      if (root) {
        initAhlAlHajj(root);
      }
    }
  );
})();